(function() {
    'use strict';
    angular
        .module('anrescowebApp')
        .factory('CountryStateByName', CountryStateByName);

    CountryStateByName.$inject = ['$resource'];

    function CountryStateByName ($resource) {
        var resourceUrl =  'api/states/:name';

        return $resource(resourceUrl, {name: '@name'}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();
